var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuHoverArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 200.79365079365078,
    viewBox: "0, 0, 400,200.79365079365078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M194.684 2.579 C 189.293 8.247,184.119 22.626,178.190 48.413 C 172.967 71.128,166.613 89.433,159.758 101.511 C 135.535 144.190,105.294 164.878,47.222 178.500 C 15.120 186.030,0.000 192.582,0.000 198.965 L 0.000 200.794 200.000 200.794 C 396.811 200.794,400.000 200.769,400.000 199.267 C 400.000 192.522,385.005 186.085,350.794 178.143 C 278.592 161.383,239.279 123.794,223.413 56.349 C 218.160 34.017,217.167 30.123,214.914 23.016 C 208.436 2.584,201.420 -4.503,194.684 2.579 ",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHoverArrow);
export default __webpack_public_path__ + "static/media/menu_hover_arrow.79b7170ab2034892c8fffaaea92cced3.svg";
export { ForwardRef as ReactComponent };